import { styled } from 'styled-components';
import { getFontSize } from '../../../../abstracts/typography';
import { breakpoints } from '../../../../abstracts/breakpoints';
import { ModalHeader as ModalHeaderBase, ModalTitle as ModalTitleBase, ModalSubTitle as ModalSubTitleBase, ModalMain as ModalMainBase, ModalScrollContainer as ModalScrollContainerBase } from '../DefaultModal/elements';
import { dontForwardProps } from '../../../../util';
export const ModalScrollContainer = ModalScrollContainerBase;
export const ModalHeader = styled(ModalHeaderBase).withConfig({
  componentId: "aui__sc-jh1e2b-0"
})(["padding-bottom:0.25rem;display:flex;flex-direction:column;margin-top:2rem;align-items:center;overflow-x:hidden;margin-right:0;@media only screen and (", "){margin-right:2.5rem;margin-top:0;flex-direction:row;align-items:center;}"], breakpoints.lgMin);
export const ModalTitleGroup = styled.div.withConfig({
  componentId: "aui__sc-jh1e2b-1"
})(["text-align:center;align-self:normal;@media only screen and (", "){text-align:left;}"], breakpoints.lgMin);
export const ModalTitle = styled(ModalTitleBase).withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-jh1e2b-2"
})(["font-size:", ";@media only screen and (", "){font-size:", ";}"], ({
  fontSize
}) => Number.isInteger(fontSize) ? getFontSize(fontSize) : getFontSize(4), breakpoints.lgMin, ({
  fontSize
}) => Number.isInteger(fontSize) ? getFontSize(fontSize) : getFontSize(5));
export const ModalMain = ModalMainBase;
export const ModalSubTitle = ModalSubTitleBase;
export const ModalIllustration = styled.div.withConfig({
  componentId: "aui__sc-jh1e2b-3"
})(["display:flex;margin-bottom:1rem;justify-content:center;align-items:flex-start;@media only screen and (", "){margin-right:1rem;margin-bottom:0;}> span > svg{display:block;}"], breakpoints.lgMin);